export enum RequestStatus {
	Success = 1,
	Failed = 2,
	Loading = 3,
	None = 0
}